import http from '@/server/httpServer.js'

/**
 * 用户登录
 * @return {promise}
 * 
 */
/* 用户登录通过手机号码 */
export const userLoginByMobile = (data) => {
    return http({ url: '/videoMeeting/user/userLoginByMobile', method: 'post' }, data)
}

/* 获取短信验证码 */
export const getSMSCode = (data) => {
    return http({ url: '/videoMeeting/user/getSMSCode', method: 'post' }, data)
}

/* 找回密码 */
export const resetUserPassWord = (data) => {
    return http({ url: '/videoMeeting/user/resetUserPassWord', method: 'post' }, data)
}

/* 用户退出登录 */
export const loginOut = (data) => {
    return http({ url: '/videoMeeting/user/loginOut', method: 'post' }, data)
}

/* 刷新token */
export const refreshToken = (data) => {
    return http({ url: '/videoMeeting/user/refreshToken', method: 'post' }, data)
}

/* 普通用户注册 */
export const registerUser = (data) => {
    return http({ url: '/videoMeeting/user/registerUser', method: 'post' }, data)
}

/* 修改密码 */
export const updatePassword = (data) => {
    return http({ url: '/videoMeeting/user/updatePassword', method: 'post' }, data)
}
/* 显示实名认证⼆维码 */
export const showRealNameVerifyQRCode = (data, jsonfile) => {
    return http({ url: `/videoMeeting/user/showRealNameVerifyQRCode?${jsonfile}`, method: 'get' }, data)
}
/* PC端定时获取实名认证状态 */
export const getRealNameVerifyStatus = (data) => {
    return http({ url: '/videoMeeting/user/getRealNameVerifyStatus', method: 'post' }, data)
}

// 获取秘钥信息
export const getPublicKey = (data) => {
    return http({url: '/videoMeeting/user/getPublicKey' }, data)
}